import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { Alert } from 'antd'
import AcvList from './AcvList'
import AcvCreate from './AcvCreate'
import AcvView from './AcvView'
import { hasPermission } from './helpers'
import './style.css'

const AssetConditionVoucher = ({ match, authUser }) => (
  <div className='asset-condition-voucher'>
    <Switch>
      <Route
        path={`${match.url}/add`}
        render={(props) => hasPermission(authUser, 'c')
          ? <AcvCreate {...props} />
          : <Alert type='error' showIcon message='You do not have permission to create an Asset Condition Voucher' />}
      />
      <Route path={`${match.url}/view/:id`} render={(props) => <AcvView {...props} />} />
      <Route path={`${match.url}`} exact render={(props) => <AcvList {...props} authUser={authUser} />} />
    </Switch>
  </div>
)

const mapStateToProps = ({ auth }) => ({ authUser: auth.authUser })

export default connect(mapStateToProps)(AssetConditionVoucher)
